



















































































import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import UserAPI from '@/services/UserAPI';
import SessionService from '@/services/SessionService';

import User from '@/types/User';
import Order from '@/types/Order';
import { UserRole } from '@/types/UserRole';

import NavbarBurger from '@/components/Bulma/NavbarBurger.vue';
import NavbarItem from '@/components/Bulma/NavbarItem.vue';
import NavbarDropdown from '@/components/Bulma/NavbarDropdown.vue';

export default Vue.extend({
	name: 'Navbar',

	components: {
		NavbarDropdown,
		NavbarBurger,
		NavbarItem
	},

	data() {
		return {
			showNav: false,
			userRole: UserRole,
			selectedDropdown: ''
		};
	},

	beforeCreate() {
		if (!document.body.classList.contains('has-navbar-fixed-top')) {
			document.body.classList.toggle('has-navbar-fixed-top');
		}
	},

	computed: {
        ...mapState(['language']),
		...mapGetters([
			'numberOrderItems',
			'numberProductsCollection',
			'numberProductLikes',
			'getUserRole',
			'isSignedIn',
			'getSiteSupportedLanguageCountries'
			])
	},

	methods: {
        ...mapActions(['changeLanguage']),

		toogleNavbar() {
			this.showNav = !this.showNav;
		},

		moveToTop() {
			window.scrollTo(0, 0);
		},

		updateSelectedDropdown(selected: string): void {
			this.selectedDropdown = this.selectedDropdown !== selected ? selected : '';
		},

		changeLanguageWrapper(language: string) {
			this.changeLanguage(language);
			const currentRoutePath = this.$router.currentRoute.path;
			const currentRoutePathSections = currentRoutePath.split('/');
			currentRoutePathSections.splice(1, 1, language);
			this.$router.push(currentRoutePathSections.join('/'));
		},

		signOut() {
			const handleResponse = (response: AxiosResponse) => {
					this.$store.commit('setUser', new User());
					this.$store.commit('setOrder', new Order());
					SessionService.removeSession();
					this.$router.push('/' + this.language);
				};

			const handleError = (error: AxiosError) => {
					if (error.response) {
						return;
					}
				};

			UserAPI
				.signOut()
				.then(handleResponse)
				.catch(handleError);
		}
	}
});
